module.exports = __webpack_public_path__ + "assets/img/warrior-name-5ef2dac4.png";